import Repo from './Base';
import authService from '../components/api-authorization/AuthorizeService';

const resource = '/api/impersonation';

export default {

  async startImpersonation(userId) {
    const token = await authService.getAccessToken();
    let result = await Repo.post(
      `${resource}/start/${userId}`, 
      {},
      { headers: !token ? {} : { 'Authorization': `Bearer ${token}` } }
    );
    if (result.status === 200) {
      return result.data;
    } else {
      throw result;
    }
  },

  async stopImpersonation() {
    const token = await authService.getAccessToken();
    let result = await Repo.post(
      `${resource}/stop`, 
      {},
      { headers: !token ? {} : { 'Authorization': `Bearer ${token}` } }
    );
    if (result.status === 200) {
      return result.data;
    } else {
      throw result;
    }
  },

  async getStatus() {
    const token = await authService.getAccessToken();
    let result = await Repo.get(
      `${resource}/status`, 
      { headers: !token ? {} : { 'Authorization': `Bearer ${token}` } }
    );
    if (result.status === 200) {
      return result.data;
    } else {
      throw result;
    }
  },

  async listUsers(page = 1, pageSize = 20, search = '') {
    const token = await authService.getAccessToken();
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('pageSize', pageSize);
    if (search) {
      params.append('search', search);
    }
    
    let result = await Repo.get(
      `${resource}/users?${params.toString()}`, 
      { headers: !token ? {} : { 'Authorization': `Bearer ${token}` } }
    );
    if (result.status === 200) {
      return result.data;
    } else {
      throw result;
    }
  }
};
